import { SEO } from "./seo"

export class Blog {
    id?: any;
    title?: any;
    subtitle?: any;
    image?: any;
    content?: any;
    isValid?: boolean;

    startPublicationDate?: any;
    isPublished?: boolean;

    idSeoFk?: any;

    seo?: SEO;
}